import { useTranslation } from 'react-i18next';
import { Card } from 'reactstrap';

import { TranslationsKeys } from '../../../locales/translations';
import HomologationDataLoader, {
  HomologationTableContainer,
} from './parts/HomologationDataLoader';
import HomologationFilterLoader from './parts/HomologationFilterLoader';
import HomologationSearchBar from './parts/HomologationSearchBar';
import HomologationTable from './parts/HomologationTable';

export default function HomologationRequestsList() {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION);

  return (
    <div className="mx-3">
      <Card className="p-4">
        <p className="mb-4 text-muted">{t('description')}</p>
        <HomologationFilterLoader>
          <HomologationDataLoader>
            <HomologationSearchBar />
            <HomologationTableContainer>
              <HomologationTable />
            </HomologationTableContainer>
          </HomologationDataLoader>
        </HomologationFilterLoader>
      </Card>
    </div>
  );
}
